const API = process.env.REACT_APP_BACKEND_URL || "http://localhost:8000";

function fireAndForget(url) {
  try {
    fetch(url, { method: "POST", keepalive: true }).catch(() => {});
  } catch {
    /* ignore */
  }
}

export function recordCampaignClick(id) {
  if (!id) return;
  fireAndForget(`${API}/api/campaigns/${encodeURIComponent(id)}/click`);
}

export function recordContentEventClick(id) {
  if (!id) return;
  fireAndForget(`${API}/api/content-events/${encodeURIComponent(id)}/click`);
}
